import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';
import { IonicSelectableComponent } from 'ionic-selectable';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';

import { RegistrationAffiliated } from '../../models/registrationaffiliated';

/**
 * Generated class for the UpdateRegistrationAffiliatedPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-affiliated',
  templateUrl: 'update-registration-affiliated.html',
})
export class UpdateRegistrationAffiliatedPage {

  private user: any;
  public registrationAffiliated: RegistrationAffiliated;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider
  ) {
    this.registrationAffiliated = new RegistrationAffiliated();

    this.user = this.authProvider.getUser();
    if (this.user) {
      this.registrationAffiliated.federalCode = this.user.affiliatedFederalCode;
      this.registrationAffiliated.name = this.user.affiliatedName;
      this.registrationAffiliated.courseCode = this.user.courseCode;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationAffiliatedPage');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doSave() {
    if ((!this.validatorProvider.isEmpty(this.registrationAffiliated.federalCode)) && (!this.validatorProvider.isCnpj(this.registrationAffiliated.federalCode))) {
      this.registrationAffiliated.federalCode = null;
    }

    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar a empresa.', 'Atenção');
/*    } else if (this.validatorProvider.isEmpty(this.registrationAffiliated.courseCode)) {
      this.alertProvider.doAlert('Forneça o código de curso.', 'Atenção');
    } else if (!this.validatorProvider.isCourseCodeBradesco(this.user.federalCode, this.registrationAffiliated.courseCode)) {
      this.alertProvider.doAlert('Forneça um código de curso válido.', 'Atenção');
*/    } else {
      let that = this;
      this.alertProvider.doConfirm('Deseja salvar a empresa?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        that.authProvider.updateAffiliated(that.registrationAffiliated).subscribe((response: any) => {
          if ((response) && (response.updated)) {
            that.alertProvider.doAlert('Seus dados pessoais foram salvos com sucesso.', 'Informação');
            loader.dismiss();

            // Update local user data
	    that.user.affiliatedFederalCode = that.registrationAffiliated.federalCode;
            that.user.affiliatedName = that.registrationAffiliated.name;
            that.user.courseCode = that.registrationAffiliated.courseCode;

            that.authProvider.setUser(that.user);
            that.eventEmitterProvider.get('registration_updated').emit(that.user);

            that.onBack();
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Houve problemas ao tentar salvar a empresa. Tente novamente mais tarde.', 'Atenção');
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Houve problemas ao tentar salvar a empresa. Tente novamente mais tarde.', 'Atenção');
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-affiliated/update-registration-affiliated.ts